module.exports = __webpack_public_path__ + "img/307.png";